// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.prd-search-result-box {
    height: 600px;
    overflow: scroll;
    width: 600px
}

.prd-search-result {
    display: flex;
    justify-content: space-between;
    align-items: center;
    border: 2px solid black;
    padding: 1rem;
    gap: 1rem;
    margin: 10px !important;
    border-radius: 10px !important;
}

.prd-search-result-body {
    display: flex;
    align-items: center;
    gap: 10px;
    flex: 1;
    cursor: pointer;
    border-radius: 8px;
    padding: 4px 6px;
    transition: background 0.15s;
}
.prd-search-result-body:hover {
    background: rgba(42, 113, 255, 0.07);
}

.search-result-product-name {
    font-size: 13px;
    font-weight: 600;
    margin: 0 0 2px;
    color: #1e293b;
}
.search-result-barcode {
    font-size: 11px;
    color: #64748b;
    margin: 0;
    font-family: "Courier New", monospace;
}

.dark .prd-search-result {
    border: 2px solid white;
}

.prd-detail-img {
    width: 40px;
    height: 40px;
}

.search-found-prd {
    text-align: center;
    color: black;
}

.dark .search-found-prd {
    color: white;
}
.dark .prd-search-result-body:hover {
    background: rgba(255, 255, 255, 0.06);
}
.dark .search-result-product-name {
    color: #e2e8f0;
}
.dark .search-result-barcode {
    color: #94a3b8;
}`, "",{"version":3,"sources":["webpack://./client/src/layouts/ecommerce/posnavbar/components/productDetail/components/searchResult/index.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,gBAAgB;IAChB;AACJ;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,uBAAuB;IACvB,aAAa;IACb,SAAS;IACT,uBAAuB;IACvB,8BAA8B;AAClC;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,OAAO;IACP,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,4BAA4B;AAChC;AACA;IACI,oCAAoC;AACxC;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,eAAe;IACf,cAAc;AAClB;AACA;IACI,eAAe;IACf,cAAc;IACd,SAAS;IACT,qCAAqC;AACzC;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,kBAAkB;IAClB,YAAY;AAChB;;AAEA;IACI,YAAY;AAChB;AACA;IACI,qCAAqC;AACzC;AACA;IACI,cAAc;AAClB;AACA;IACI,cAAc;AAClB","sourcesContent":[".prd-search-result-box {\n    height: 600px;\n    overflow: scroll;\n    width: 600px\n}\n\n.prd-search-result {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    border: 2px solid black;\n    padding: 1rem;\n    gap: 1rem;\n    margin: 10px !important;\n    border-radius: 10px !important;\n}\n\n.prd-search-result-body {\n    display: flex;\n    align-items: center;\n    gap: 10px;\n    flex: 1;\n    cursor: pointer;\n    border-radius: 8px;\n    padding: 4px 6px;\n    transition: background 0.15s;\n}\n.prd-search-result-body:hover {\n    background: rgba(42, 113, 255, 0.07);\n}\n\n.search-result-product-name {\n    font-size: 13px;\n    font-weight: 600;\n    margin: 0 0 2px;\n    color: #1e293b;\n}\n.search-result-barcode {\n    font-size: 11px;\n    color: #64748b;\n    margin: 0;\n    font-family: \"Courier New\", monospace;\n}\n\n.dark .prd-search-result {\n    border: 2px solid white;\n}\n\n.prd-detail-img {\n    width: 40px;\n    height: 40px;\n}\n\n.search-found-prd {\n    text-align: center;\n    color: black;\n}\n\n.dark .search-found-prd {\n    color: white;\n}\n.dark .prd-search-result-body:hover {\n    background: rgba(255, 255, 255, 0.06);\n}\n.dark .search-result-product-name {\n    color: #e2e8f0;\n}\n.dark .search-result-barcode {\n    color: #94a3b8;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
